var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99982 16.0801V7.91012C1.99982 4.38012 4.27082 2.00012 7.65982 2.00012H16.3298C19.7198 2.00012 21.9998 4.38012 21.9998 7.91012V16.0801C21.9998 19.6201 19.7198 22.0001 16.3298 22.0001H7.65982C4.27082 22.0001 1.99982 19.6201 1.99982 16.0801ZM11.4557 16.0961V14.8276H14.0911V13.5345H11.4557V12.5246H13.4138C14.2184 12.5246 14.8506 12.3071 15.3103 11.8719C15.7701 11.4368 16 10.8169 16 10.0123C16 9.20772 15.7701 8.58785 15.3103 8.15271C14.8506 7.71757 14.2184 7.5 13.4138 7.5H9.58374V11.2315H8.5V12.5246H9.58374V13.5345H8.5V14.8276H9.58374V16.0961H11.4557ZM13.1798 11.2315H11.4557V9.01478H13.1798C13.459 9.01478 13.6765 9.08046 13.8325 9.21182C13.9967 9.33498 14.0788 9.53612 14.0788 9.81527V10.3571C14.0788 10.6363 14.0008 10.8539 13.8448 11.0099C13.6888 11.1576 13.4672 11.2315 13.1798 11.2315Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGray);
export default __webpack_public_path__ + "static/media/SearchGray.f868d509ec8b8fe5e31ce90f850f7ae0.svg";
export { ForwardRef as ReactComponent };